import {
  SET_LAYOUT,
  SET_VIEW,
  SET_ADMIN_NAV,
  SET_ALERT_MODAL,
} from './types';

export const setLayout = (layout) => {
  return {
    type: SET_LAYOUT,
    payload: layout
  }
};

export const setView = (view) => {
  return {
    type: SET_VIEW,
    payload: view
  }
};

export const setAdminNav = (payload) => {
  return {
    type: SET_ADMIN_NAV,
    payload: payload,
  }
}

export const showAlertModal = (payload) => {
  return {
    type: SET_ALERT_MODAL,
    payload: payload,
  }
}



